import React from 'react';
import useAuth from '~/hooks/useAuth';
import { Permission } from '~/types/auth';

type PermCheckProps = {
  permissions: Permission | Permission[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

const PermCheck: React.FC<PermCheckProps> = ({ permissions, children, fallback }) => {
  const { hasPermission } = useAuth();
  return hasPermission(permissions) ? <>{children}</> : <>{fallback}</>;
};

export default PermCheck;
